import axios from '../utils/setupAxiosAuth';
import { getAdminApiBaseUrl } from '../utils/adminApiBaseUrl';
import { getAuthHeaders } from '../utils/authHeaders';

export type SellerAcquisitionCampaignRow = {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  market_landings: number;
  seller_register_clicks: number;
  seller_register_starts: number;
  seller_register_step2: number;
  registration_requests: number;
  sellers_created: number;
  click_rate_pct: number;
  step2_rate_pct: number;
};

export type SellerAcquisitionResponse = {
  campaigns: SellerAcquisitionCampaignRow[];
  totals: {
    market_landings: number;
    seller_register_clicks: number;
    seller_register_starts: number;
    seller_register_step2: number;
    registration_requests: number;
    sellers_created: number;
  };
};

export const fetchSellerAcquisitionCampaigns = async (
  fromDate: string,
  toDate: string,
  utmCampaign?: string
): Promise<SellerAcquisitionResponse> => {
  const apiBase = getAdminApiBaseUrl().replace(/\/?$/, '/');
  const response = await axios.get(`${apiBase}customers/seller-acquisition-campaigns`, {
    params: {
      from_date: fromDate,
      to_date: toDate,
      utm_campaign: utmCampaign || undefined,
    },
    headers: getAuthHeaders(),
  });
  return response.data;
};
